export default "__VITE_ASSET__DmzO4z32__"